import React from "react";

function Foooter(props) {
    return(
        <>©HandySham 2025 </>
    )
}
export default Foooter;